import { accordionSummaryClasses, styled } from '@mui/material';
import MuiAccordion, { accordionClasses, AccordionProps } from '@mui/material/Accordion';

const borderRadius = 8;

export const AccordionStyled = styled((props: AccordionProps) => <MuiAccordion {...props} />)(() => ({
  background: 'unset',
  margin: 2,
  [`&.${accordionClasses.root}:before, &.${accordionClasses.expanded}:before`]: {
    opacity: 0,
  },
  [`&.${accordionClasses.disabled}`]: {
    opacity: 1,
    backgroundColor: 'unset',
  },
  [`:first-of-type, :first-of-type .${accordionSummaryClasses.root}`]: {
    borderTopRightRadius: borderRadius,
    borderTopLeftRadius: borderRadius,
  },
}));
